// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-input[data-v-417ed09e]{font-family:var(--font-main);align-items:center;border:1px solid var(--border);border-radius:var(--round-corner-small);display:flex;flex-grow:1;font-size:var(--font-size-16);padding:0 var(--space-16);margin:0;-webkit-appearance:none;appearance:none}.text-input.invalid[data-v-417ed09e]{border-color:var(--red)!important}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
